<template>
    <Loader v-if="loading" class="table-loader" />
    <div v-else>
        <table>
            <thead>
                <tr>
                    <th v-for="(col,index) in columns" :key="`${col.key}-${index}`">
                        <span class="text-left">{{col.title}} </span>
                        <div 
                            v-if="col.sortable" 
                            style="cursor: pointer" 
                            class="d-inline-block" 
                            @click="sortRows" 
                            :class = "$route.query.sortBy || 'desc'"
                        >
                            <Icon 
                                style="margin-bottom: -8px;" 
                                icon="arrow-up-filled" 
                                class="d-block"
                            />
                            <Icon 
                                style="margin-top: 4px" 
                                icon="arrow-down-filled" 
                            />
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody v-for="row in data" :key="row.id">
                <tr 
                    @click.stop="!row.notExpandable ? toggleRowExpand(row.id) : void(0)" 
                    :class="{ 
                        opened: expandedRow === row.id, 
                        notExpandable: row.notExpandable, 
                        'unSeen': row.seen === false,
                        'received-requests-row': $route.name === 'requests' && ($route.query.type === 'received' || !$route.query.type),
                        'sent-requests-row': $route.name === 'requests' && $route.query.type === 'sent',
                        'scheduled-updates-row': $route.name === 'updates' && ($route.query.type === 'scheduled' || !$route.query.type),
                        'scheduled-updates-row': $route.name === 'updates' && $route.query.type === 'unscheduled',
                    }">
                    <td 
                        v-for="(col, index) in columns" 
                        :key="`${col.key}-${index}`" 
                        :class="{'received': $route.name === 'requests' && ($route.query.type === 'received' || !$route.query.type)}">
                            <slot 
                                v-if="col.slot" 
                                :row="row"
                                :expanded = "expandedRow === row.id"
                                :name="col.slot.name"/>
                            <span v-else>{{row[col.key]}}</span>
                    </td>
                    <td v-if="!row.notExpandable">
                        <Icon :icon="expandedRow === row.id ? arrowUp: arrowDown"/>
                    </td>
                </tr>
                <ExpandedRow v-if="expandedRow === row.id" :data = "row" :set-expanded-data = "setExpandedData"/>
            </tbody>
        </table>
    </div>
</template>

<script>
import useRequestExpand from './useRequestExpand'
import ExpandedRow from './ExpandedRow'
import Icon from '@/components/Theme/Icon'
import {Loader} from '../../../../components/Icons'
import {useRouter, useStore} from '../../../../core/hooks'

export default {
    name: 'Table',
    components: {
        ExpandedRow,
        Loader,
        Icon
    },
    props: {
        columns: Array,
        data: Array,
        setExpandedData: Function,
        loading: Boolean,
        seen: Boolean
    },
    setup(props, context) {
        let { expandedRow, toggleExpand } = useRequestExpand()
        const arrowDown = 'row-down-arrow-icon'
        const arrowUp = 'row-up-arrow-icon'
        const {route, router} = useRouter();
        const {store} = useStore();

        const toggleRowExpand = (rowId) => {
            toggleExpand(rowId)
            context.root.$sendMixpanelEvent('Dashboard Row Expanded', {
                'Page Name': route.value.name
            })
            context.root.$ga.event('Dashboard', 'Row Expanded', 'Location', route.value.name)
        }

        const sortRows = () => {
            const order = (!route.value.query.sortBy || route.value.query.sortBy === 'desc') ? 'asc' : 'desc'
            router.replace({
                query: {
                    ...route.value.query,
                    sortBy: order
                }
            }).catch(() => {})
        }

        return {
            expandedRow,
            toggleRowExpand,
            arrowDown,
            arrowUp,
            sortRows
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables.scss';
@import '../../../../assets/scss/mixins';
.asc {
    img:last-child {
        filter: opacity(50%)
    }
}
.desc {
    img:first-child {
        filter: opacity(50%)
    }
}
table {
    width: 100%;
    color: $c6;
    thead {
        tr {
            height: 50px; 
            border-bottom: 1px solid $c28;
            
            th {
                text-transform: uppercase;
                font-size: $p5;
                font-weight: $weight_bold;
                text-align: left;

                &:first-child {
                    padding-left: 32px;
                }
            }
            
        }
    }
    tbody {
        tr {
            height: 56px;
            border-bottom: 1px solid $c28;
            cursor: pointer;
            &.unSeen {
                background-image: url(/icons/new-icon.svg);
                background-repeat: no-repeat;
                background-size: 28px;
                background-position: left center;
                td {
                    font-weight: $weight_bold;
                }
            }
            &:first-child {
                border-top: 1px solid $c28;
            }

            td {
                padding-left: 0;
                &:first-child {
                    padding-left: 32px;
                }
                &.received {

                    &:nth-last-child(2) {
                        width: 100px;
                    }
                }
            }
            &.opened {
                background: #F7F7FE;
            }
            &.notExpandable {
                cursor: default;
            }
        }
    }
}
</style>